import { CssBaseline } from '@mui/material';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { configureApi } from './services/api';
import { useAuthStore } from './store/auth.store';
import { ThemeContextProvider } from './theme/ThemeContextProvider';
import './theme/app.css'
// Bridge the auth store into the HTTP client (keeps them decoupled).
configureApi({
  onUnauthorized: () => useAuthStore.getState().clear(),
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <ThemeContextProvider>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeContextProvider>
  </StrictMode>,
);